/**
 * @file bug.form.tsx
 * @description Форма для создания и редактирования записей о багах/дефектах в системе.
 * Включает поля для описания дефекта, указания сервиса, функции, контура, приоритета,
 * информации о релизе с дефектом, дате регистрации, релизе с исправлением, дате устранения и ответственном.
 * Интегрируется с react-hook-form через control prop.
 * @author AI Assistant
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, @components/form-controls/date-picker, @components/form-controls/chips-choice, @components/form-controls/dictionary, @consta/uikit/Text]
 * @related-files [@components/form-controls/date-picker/date-picker.component.tsx, @components/form-controls/chips-choice/chips-choice.component.tsx, @components/form-controls/dictionary/dictionary.component.tsx]
 */

import { DatePicker } from '@components/form-controls/date-picker';
import { ChipsChoice } from '@src/components/form-controls/chips-choice';
import { Dictionary } from '@components/form-controls/dictionary';
import { Text } from '@consta/uikit/Text';
// import { IBugDTO } from '@src/types/dto'; // DTO доступно для AI помощников

export const BugForm = ({ control }: any) => {
    return (
        <div className="flex flex-col gap-[1.0585vmin]">
            <Dictionary label="Сервис" name="service" control={control} />

            <Dictionary label="Функция" name="functionalRequirement" control={control} />

            <ChipsChoice label="Контур" name="contour" control={control} view="ghost" />

            <ChipsChoice label="Приоритет" name="priority" control={control} view="priority" />

            <div className="flex flex-col">
                <Text size="s" className="whitespace-nowrap dictionary__label font-medium leading-[2.5405vmin]">
                    Дефект
                </Text>

                <div className="flex gap-default">
                    <Dictionary label="Релиз" name="releaseBug" control={control} />

                    <DatePicker label="Дата регистрации" name="dateBug" control={control} />
                </div>
            </div>

            <div className="flex flex-col">
                <Text size="s" className="whitespace-nowrap dictionary__label font-medium leading-[2.5405vmin]">
                    Исправление
                </Text>

                <div className="flex gap-default">
                    <Dictionary label="Релиз" name="releaseFix" control={control} />

                    <DatePicker label="Дата устранения" name="dateFix" control={control} />
                </div>
            </div>

            <Dictionary label="Ответственный" name="executor" control={control} />
        </div>
    );
};
